import React from 'react'

const JS_Essentials_Coding_Pratice_3 = () => {
  return (
    <div>
      <h1>Coding Practice 3</h1>
    </div>
  )
}

export default JS_Essentials_Coding_Pratice_3
